import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { ValuePickerProps } from './types'
import { Input } from '@/components/ui/input'

export function TextFilterInput({
  selectedValues,
  onToggleValue,
}: ValuePickerProps) {
  const { t } = useTranslation('tasks')
  const currentText = (selectedValues[0] as string) ?? ''
  const [inputValue, setInputValue] = useState(currentText)

  // Sync external changes
  useEffect(() => {
    setInputValue(currentText)
  }, [currentText])

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value
      setInputValue(val)
      // For text filters, we replace the single value
      // Use onToggleValue with the new text — the store's setValues handles replacement
      // We need a slight delay to debounce
      clearTimeout((handleChange as any)._timer)
      ;(handleChange as any)._timer = setTimeout(() => {
        // Call parent with new value — parent should use setValues, not toggleValue
        onToggleValue(val)
      }, 300)
    },
    [onToggleValue],
  )

  return (
    <div className="p-2">
      <Input
        placeholder={t('filterBar.textPlaceholder')}
        value={inputValue}
        onChange={handleChange}
        className="h-8 text-sm"
        autoFocus
      />
    </div>
  )
}
